import { render, staticRenderFns } from "./hourly-promotion.vue?vue&type=template&id=89b2d1d2&"
import script from "./hourly-promotion.vue?vue&type=script&lang=js&"
export * from "./hourly-promotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports